
// ExportZohoDialog.js
import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material'

const ExportZohoDialog = ({ open, onClose, onConfirm, plantName, invoiceNumber }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Export to Zoho</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to export this invoice to Zoho?
        </Typography>
        {plantName && (
          <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
            Plant: {plantName}
          </Typography>
        )}
        <Typography variant="body2" sx={{ mt: 2, fontWeight: 'bold' }}>
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          Export to Zoho
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ExportZohoDialog